// extracted by mini-css-extract-plugin
export default {"disabled":"iconBtn_disabled__QV+nb"};